<template>
    <Breadcrumbs main="E-Commerce" title="Product List" />
    <div class="container-fluid">
        <div class="row">
            <listTable />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const listTable = defineAsyncComponent(() => import("@/components/theme/ecommerce/productlist/listTable.vue"))
</script>